import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ServiceUrlsService } from './common-service/service-urls/service-urls.service';
import { HomePageComponent } from './home-page/home-page.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { BodyComponent } from './layout/body/body.component';
import { ResendVerificationEmailService } from './signup-success/service/resend-verification-email.service';
import { SignupService } from './signup/service/signup.service';
import { SignupComponent } from './signup/signup.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'angular-google-recaptcha';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { SignupSuccessComponent } from './signup-success/signup-success.component';
import { PaymentComponent } from './payment/payment.component';
import { PlansComponent } from './plans/plans.component';
import { VerifyEmailService } from './verify-email/service/verify-email.service';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import {ModalModule} from 'ng-bootstrap-modal';
import { SignupDialogComponent } from './signup-dialog/signup-dialog.component';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { LocalStorageService } from './common-service/local-storage/local-storage.service';
import { SubscriptionPlansService } from './subscription-plans/service/subscription-plans.service';
import { PremiumPlanService } from './plans/service/premium-plan.service';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { MsSignupSuccessComponent } from './ms-signup-success/ms-signup-success.component';
import { MoveNextByMaxLengthDirective } from './directives/move-next-by-max-length.directive';
import { MsSignupDialogComponent } from './ms-signup-dialog/ms-signup-dialog.component';
import { AuthGuardService } from './common-service/auth-guard/auth-guard.service';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import {MsalModule} from '@azure/msal-angular';
import { MsalInterceptor} from '@azure/msal-angular';
import {LogLevel} from 'msal';
import { ModalDirective } from './directives/modal.directive';
import { FreeTrialComponent } from './free-trial/free-trial.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { LightboxModule } from 'ngx-lightbox';


export function loggerCallback(logLevel, message, piiEnabled) {
  console.log('client logging: ----- ' + message);
}

@NgModule({
  declarations: [
    AppComponent,
    HomePageComponent,
    HeaderComponent,
    FooterComponent,
    BodyComponent,
    SignupComponent,
    SignupSuccessComponent,
    PaymentComponent,
    PlansComponent,
    VerifyEmailComponent,
    SignupDialogComponent,
    SubscriptionPlansComponent,
    PaymentSuccessComponent,
    MsSignupSuccessComponent,
    MoveNextByMaxLengthDirective,
    MsSignupDialogComponent,
    PrivacyPolicyComponent,
    ModalDirective,
    FreeTrialComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    ToastrModule.forRoot(),
    LightboxModule,
    RecaptchaModule.forRoot({
            // siteKey: '6LeyPWIUAAAAAAKeMGeVmdllPOj0vGr-XSMEYxUg',
            siteKey: '6LcOErQUAAAAANyQCtNPAxMM1lQpkvxwEfcLlJki',
        }),

    MsalModule.forRoot({
      clientID: '0a5622dc-e908-472d-a8e9-0e826c637770',
      authority: 'https://login.microsoftonline.com/common/',
      validateAuthority: true,
      redirectUri: 'https://executive-eye.com/subscription-plans',
      // redirectUri: 'http://localhost:3000/subscription-plans",
      cacheLocation : 'localStorage',
      // postLogoutRedirectUri: 'http://localhost:3000",
      navigateToLoginRequestUrl: false,
      popUp: false,
      consentScopes: ['user.read'],
      // unprotectedResources: ['https://www.microsoft.com/en-us/',
      //                        'http://localhost:3000/api/',
      //                        'http://localhost:3000/api/client/registerClient",
      //                        'http://localhost:3000/api/client/resendVerificationEmail",
      //                        'http://localhost:3000/api/client/verifyEmail",
      //                        'http://localhost:3000/api/client/subscribeTrialPlan",
      //                        'http://localhost:3000/api/client/subscribePremiumPlan",
      //                        'http://localhost:3000/api/client/sendSupportEmail",
      //                        'http://localhost:3000/api/client/registerClient",
      //                        'http://localhost:3000/api/microsoft/ms-access-token"],
     unprotectedResources: ['https://www.microsoft.com/en-us/',
                            'https://executive-eye.com/api/',
                            'https://executive-eye.com/api/client/registerClient',
                            'https://executive-eye.com/api/client/resendVerificationEmail',
                            'https://executive-eye.com/api/client/verifyEmail',
                            'https://executive-eye.com/api/client/subscribeTrialPlan',
                            'https://executive-eye.com/api/client/subscribePremiumPlan',
                            'https://executive-eye.com/api/client/sendSupportEmail',
                            'https://executive-eye.com/api/client/registerClient',
                            'https://executive-eye.com/api/microsoft/ms-access-token'],
      // rotectedResourceMap: protectedResourceMap,
      logger: loggerCallback,
      correlationId: '1234',
      level: LogLevel.Info,
      piiLoggingEnabled: true
      }
    ),

    ModalModule.forRoot([ { name: 'signupDialog', component: SignupDialogComponent},
    { name: 'msSignupDialog', component: MsSignupDialogComponent}])
  ],
  providers: [SignupService,
              ServiceUrlsService,
              NgxSpinnerService,
              ResendVerificationEmailService,
              VerifyEmailService,
              LocalStorageService,
              SubscriptionPlansService,
              PremiumPlanService,
              AuthGuardService,
             {provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true},
             ToastrService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts